<template>
  <div class="tab-selector">
    <button class="tab-button" :class="{ active: activeTab === 'store' }" @click="$emit('update:activeTab', 'store')">
      매장
    </button>
    <button
      class="tab-button"
      :class="{ active: activeTab === 'product' }"
      @click="$emit('update:activeTab', 'product')">
      제품
    </button>
  </div>
</template>

<script>
export default {
  name: 'TabSelector',
  props: {
    activeTab: {
      type: String,
      required: true,
      validator: value => ['store', 'product'].includes(value),
    },
  },
  emits: ['update:activeTab'],
};
</script>

<style scoped>
.tab-selector {
  width: 216px;
  height: 40px;
  display: inline-flex;
  background: var(--disabled-light-color);
  border-radius: 12px;
  padding: 4px;
  gap: 8px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 40px;
  }
}

.tab-button {
  flex: 1;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: transparent;
  color: #3a3a3a;

  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}

.tab-button:hover {
  color: #333;
}

.tab-button.active {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 9px 24px 0 rgba(0, 0, 0, 0.1);
  color: var(--primary-light-color);
}
</style>
